import { ReportState } from './state';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export const reportStore = {
  namespaced: true,
  state: {
    reportData: {
      isLoading: false
    },
    legMovementEvents: {
      isLoading: false
    },
    study: {
      isLoading: false
    },
    config: {
      isLoading: false
    },
    draftReport: {
      isLoading: false
    },
    finalReport: {
      isLoading: false
    },
    signed: {
      isLocked: false,
      by: 'Radu Dragan'
    },
    inputs: {
      checkedNames: [],
      technicianNote: '',
      physicianNote: ''
    }
  } as ReportState,
  actions,
  getters,
  mutations
};
